import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["popover", "badge", "list", "emptyState"]
  static values = { 
    unreadCount: { type: Number, default: 0 }
  }

  connect() {
    console.log('[Notifications] Controller connected, unread:', this.unreadCountValue)
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (this.hasPopoverTarget) {
      if (this.popoverTarget.classList.contains('hidden')) {
        this.open()
      } else {
        this.close()
      }
    }
  }

  open() {
    if (this.hasPopoverTarget) {
      this.popoverTarget.classList.remove('hidden')
      // Use setTimeout to avoid the click event that opened it
      setTimeout(() => {
        document.addEventListener('click', this.boundHandleClickOutside)
      }, 0)
    }
  }

  close() {
    if (this.hasPopoverTarget) {
      this.popoverTarget.classList.add('hidden')
      document.removeEventListener('click', this.boundHandleClickOutside)
    }
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  markAsRead(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const notificationId = event.currentTarget.dataset.notificationId
    const notificationElement = document.querySelector(`[data-notification-id="${notificationId}"]`)
    
    fetch(`/notifications/${notificationId}/mark_read`, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    }).then(response => response.json())
      .then(data => {
        if (data.success) {
          if (notificationElement) {
            notificationElement.classList.add('opacity-50')
            notificationElement.classList.remove('bg-blue-50')
          }
          this.updateBadge(data.unread_count)
        }
      })
      .catch(error => console.error('[Notifications] Error marking as read:', error))
  }

  markAllAsRead(event) {
    event.preventDefault()
    
    fetch('/notifications/mark_all_read', {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    }).then(response => response.json())
      .then(data => {
        if (data.success) {
          // Mark all notifications as read visually
          if (this.hasListTarget) {
            this.listTarget.querySelectorAll('[data-notification-id]').forEach(el => {
              el.classList.add('opacity-50')
              el.classList.remove('bg-blue-50')
            })
          }
          this.updateBadge(0)
        }
      })
      .catch(error => console.error('[Notifications] Error marking all as read:', error))
  }

  updateBadge(count) {
    this.unreadCountValue = count
    if (this.hasBadgeTarget) {
      if (count > 0) {
        this.badgeTarget.textContent = count > 99 ? '99+' : count
        this.badgeTarget.classList.remove('hidden')
      } else {
        this.badgeTarget.classList.add('hidden')
      }
    }
  }

  // Called when Turbo Stream adds a new notification
  notificationAdded(event) {
    this.unreadCountValue++
    this.updateBadge(this.unreadCountValue)
    
    // Hide empty state if visible
    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.add('hidden')
    }
  }

  disconnect() {
    document.removeEventListener('click', this.boundHandleClickOutside)
  }
}
